<template>
  <section class="how-it-works">
    <div class="how-it-works__container">
      <div class="how-it-works__header">
        <h2 class="how-it-works__title">How it works</h2>
        <p class="how-it-works__subtitle">
          Our streamlined process makes it easy for you to refer Workers' Comp cases while maintaining your client relationships.
        </p>
      </div>
      
      <div class="how-it-works__steps">
        <div class="steps-row">
          <div class="step">
            <div class="step__number">1</div>
            <div class="step__content">
              <h3 class="step__title">Submit the referral</h3>
              <p class="step__description">
                Use our lead referral portal to answer a few simple questions about the group, then click 'submit'.
              </p>
            </div>
          </div>
          
          <div class="step">
            <div class="step__number">2</div>
            <div class="step__content">
              <h3 class="step__title">We take it from there</h3>
              <p class="step__description">
                An experienced agent will handle your customers' workers' comp needs. You'll be able to view where the group is in the process through the lead referral portal.
              </p>
            </div>
          </div>
        </div>
        
        <div class="steps-row">
          <div class="step">
            <div class="step__number">3</div>
            <div class="step__content">
              <h3 class="step__title">You keep the client relationship</h3>
              <p class="step__description">
                Your client stays yours. We're just the WC back office.
              </p>
            </div>
          </div>
          
          <div class="step">
            <div class="step__number">4</div>
            <div class="step__content">
              <h3 class="step__title">You get paid</h3>
              <p class="step__description">
                Once the policy is sold, you'll get your commission without lifting a finger.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="how-it-works__separator">
        <img src="/assets/wavy-line.svg" alt="Decorative separator" class="separator-image" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HowItWorks'
}
</script>

<style scoped>
.how-it-works {
  background: white;
  padding: 120px 64px 64px 64px;
  position: relative;
  z-index: 5;
  margin-top: 0px;
}

.how-it-works__container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 48px;
}

.how-it-works__header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.how-it-works__title {
  font-family: 'Fraunces', serif;
  font-weight: 700;
  font-size: 40px;
  line-height: 1;
  color: #1e1e1e;
  letter-spacing: -1.2px;
  margin: 0;
  font-variation-settings: 'SOFT' 0, 'WONK' 1;
}

.how-it-works__subtitle {
  font-family: 'Fraunces', serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.4;
  color: #1e1e1e;
  max-width: 626px;
  margin: 0;
  font-variation-settings: 'SOFT' 0, 'WONK' 1;
}

.how-it-works__steps {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.steps-row {
  display: flex;
  gap: 32px;
}

.step {
  flex: 1;
  display: flex;
  gap: 24px;
  align-items: flex-start;
  min-width: 240px;
}

.step__number {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: white;
  color: black;
  border: 1px solid #1e1e1e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Fraunces', serif;
  font-weight: 900;
  font-size: 20px;
  line-height: 1.2;
  letter-spacing: -0.4px;
  flex-shrink: 0;
  font-variation-settings: 'SOFT' 0, 'WONK' 1;
}

.step__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 160px;
}

.step__title {
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 1.2;
  color: #1e1e1e;
  letter-spacing: -0.48px;
  margin: 0;
}

.step__description {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.4;
  color: #757575;
  margin: 0;
}

.how-it-works__separator {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.separator-image {
  width: 385px;
  height: 16px;
}

@media (max-width: 1024px) {
  .how-it-works {
    padding: 48px 32px;
  }
  
  .steps-row {
    flex-direction: column;
    gap: 24px;
  }
  
  .step {
    min-width: auto;
  }
}

@media (max-width: 768px) {
  .how-it-works {
    padding: 32px 16px;
  }
  
  .how-it-works__title {
    font-size: 32px;
  }
  
  .how-it-works__subtitle {
    font-size: 18px;
  }
  
  .step__number {
    width: 28px;
    height: 28px;
    font-size: 18px;
  }
  
  .step__title {
    font-size: 20px;
  }
  
  .step__description {
    font-size: 14px;
  }
}
</style>
